import { render, staticRenderFns } from "./sign_role.vue?vue&type=template&id=2252d7b1&"
import script from "./sign_role.vue?vue&type=script&lang=js&"
export * from "./sign_role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports